import * as React from 'react';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import LoadingWithMessage from '../../../misc/components/LoadingWithMessage';
import { ConfigureStatStripXpress2 } from './ConfigureStatStripXpress2';
import { StudyScheduleSession } from 'webportalclient';
import { useAuth } from "react-oidc-context";
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

interface StatStripXpress2ConfigureStateProps {
    subjectId: string;
    selectedDevice: Device;
    sessionScheduleItem: StudyScheduleSession; 
}

interface StatStripXpress2ConfigureDispatchProps {
    onError: (message: string) => void;
    onComplete: () => void;
}

type StatStripXpress2ConfigureProps = StatStripXpress2ConfigureStateProps & StatStripXpress2ConfigureDispatchProps; 

export const StatStripXpress2Configure = ({ subjectId, selectedDevice, sessionScheduleItem, onError, onComplete }: StatStripXpress2ConfigureProps) => {
    const { user } = useAuth();
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();

    const configure = async () => {
        await ConfigureStatStripXpress2(
            legacyClient,
            client.client,
            user?.profile.email,
            subjectId,
            selectedDevice,
            sessionScheduleItem,
            onError,
            onComplete
        );
    }

    React.useEffect(() => {
        configure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message="Configuring device..." />
        </div>
    );
}
